import React, { useContext, useEffect, useState } from "react";
import {
  CanadaIcon,
  RecycleIcon,
  LabGrownIcon,
  MinedIcon,
  BeakerIcon,
  SignatureIcon,
} from "../Icons";
import { MeleeSearchContext } from "../../utils/stateHandlers/contexts";
import _ from "lodash";
import Select from "react-select";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Shape from "./shapes/Shape";
import { Default, Mobile } from "../../utils/deviceHelpers";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";

export default function MeleeDiamondSearchFilters(props) {
  const { meleeState, meleeSearchDispatch } = useContext(MeleeSearchContext);
  const { filters, searchQuery, collections, matchedPairs } = meleeState;
  const [buttons, setButtons] = useState([]);
  const [caratSelect, setCaratSelect] = useState(null);
  const [mmSelect, setMmSelect] = useState(null);

  const ShapeFilter = () => {
    const shapeFilter = _.find(filters, function (filter) {
      return filter.name === "Shape";
    });

    function isActive(shapeName) {
      const selectedValue = _.find(searchQuery.fields, function (field) {
        return field.name === "Shape";
      });
      if (selectedValue) {
        const bool = _.find(selectedValue.values, function (value) {
          return value.name === shapeName ? true : false;
        });
        return bool;
      }
    }

    function selectShape(shapeName) {
      if (matchedPairs) {
        return;
      }
      const searchField = _.find(searchQuery.fields, function (field) {
        return field.name === "Shape";
      });
      if (searchField) {
        const shapeFound = _.find(searchField.values, function (value) {
          return value.name === shapeName;
        });
        if (shapeFound) {
          const removeSelected = _.remove(searchField.values, function (value) {
            return value.name !== shapeName;
          });
          searchField.values = removeSelected;
          meleeSearchDispatch({
            type: "updateSearchQuery",
            payload: searchQuery.fields,
          });
        } else {
          const newSelectedShapes = _.concat(searchField.values, {
            name: shapeName,
          });
          searchField.values = newSelectedShapes;
          meleeSearchDispatch({
            type: "updateSearchQuery",
            payload: searchQuery.fields,
          });
        }
      } else {
        const newSearchFields = _.concat(searchQuery.fields, {
          name: "Shape",
          values: [
            {
              name: shapeName,
            },
          ],
        });
        meleeSearchDispatch({
          type: "updateSearchQuery",
          payload: newSearchFields,
        });
      }
    }

    return (
      <div className="filter filter--shape">
        {shapeFilter.values.map((value) => (
          <div
            key={value.name}
            onClick={() => selectShape(value.name)}
            className="shape-value"
          >
            <div className="shape-icon pointer">
              <Shape
                type={
                  value.name !== "Straight Baguette"
                    ? value.name
                    : "StraightBaguette"
                }
                color={
                  isActive(value.name)
                    ? "black"
                    : matchedPairs
                    ? "#b2b2b2"
                    : "#4280aa"
                }
                stroke_width={isActive(value.name) ? "1%" : "0.4%"}
                width="40"
              />
            </div>
            <Typography
              variant="body3"
              className={[
                "pointer",
                "shape-label " +
                  (isActive(value.name)
                    ? "shape-label--selected"
                    : matchedPairs
                    ? "shape-label--matched"
                    : ""),
              ].join(" ")}
            >
              {value.name}
            </Typography>
          </div>
        ))}
      </div>
    );
  };

  function clickButton(button) {
    const alreadySelected = _.find(buttons, function (b) {
      return b === button.value;
    })
      ? true
      : false;
    if (alreadySelected) {
      const remove = _.remove(buttons, function (b) {
        return b !== button.value;
      });
      setButtons(remove);
    } else {
      setButtons([...buttons, button.value]);
    }
    const qualityFilter = _.find(searchQuery.fields, function (field) {
      return field.name === "Quality";
    });
    if (qualityFilter) {
      const valueFound = _.find(qualityFilter.values, function (value) {
        return value.name === button.value;
      });
      if (valueFound) {
        updateFilters(
          "Quality",
          _.remove(qualityFilter.values, function (filterValue) {
            return filterValue.name !== button.value;
          })
        );
      } else {
        updateFilters("Quality", [
          ...qualityFilter.values,
          { name: button.value },
        ]);
      }
    } else {
      updateFilters("Quality", [{ name: button.value }]);
    }
  }

  function updateFilters(filterName, filterValues) {
    const filterToUpdate = _.find(searchQuery.fields, function (field) {
      return field.name === filterName;
    });
    if (filterToUpdate) {
      filterToUpdate.values =
        filterName !== "Quality" ? [filterValues] : filterValues;
      meleeSearchDispatch({
        type: "updateSearchQuery",
        payload: searchQuery.fields,
      });
    } else {
      const fields = _.concat(searchQuery.fields, {
        name: filterName,
        values: filterName !== "Quality" ? [filterValues] : filterValues,
      });
      meleeSearchDispatch({ type: "updateSearchQuery", payload: fields });
    }
  }

  function updateDropdownFilters(filterName, event) {
    const filterToUpdate = _.find(searchQuery.fields, function (field) {
      return field.name === filterName;
    });
    if (filterToUpdate) {
      filterToUpdate.values = event === null ? [] : [{ name: event.value }];
      meleeSearchDispatch({
        type: "updateSearchQuery",
        payload: searchQuery.fields,
      });
    } else {
      const fields = _.concat(searchQuery.fields, {
        name: filterName,
        values: event === null ? [] : [{ name: event.value }],
      });
      meleeSearchDispatch({ type: "updateSearchQuery", payload: fields });
    }
  }

  useEffect(() => {
    const buttonFilter = _.find(searchQuery.fields, function (field) {
      return field.name === "Quality";
    });
    if (buttonFilter === undefined) {
      setButtons([]);
    }
    if (searchQuery.fields.length === 0) {
      setCaratSelect(null);
      setMmSelect(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  return (
    <>
      <Mobile>
        <Stack spacing={1} alignItems="center">
          {filters &&
            filters.map((filter, index) => (
              <React.Fragment key={index}>
                {filter.name === "ShapeCode" ? (
                  <Accordion
                    square={true}
                    disableGutters={true}
                    sx={{
                      width: "100%",
                      minHeight: "unset",
                      paddingRight: "1rem",
                    }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>{filter.label}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      {filter.type === "options" && filter.label === "Shape" ? (
                        <ShapeFilter updateFilters={updateFilters} />
                      ) : null}
                    </AccordionDetails>
                  </Accordion>
                ) : filter.name === "CaratRange" ? (
                  <Accordion
                    square={true}
                    disableGutters={true}
                    sx={{
                      width: "100%",
                      minHeight: "unset",
                      paddingRight: "1rem",
                    }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>{filter.label}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Select
                        key={filter.name}
                        value={caratSelect}
                        onChange={(e) => {
                          setCaratSelect(e);
                          updateDropdownFilters(filter.name, e);
                        }}
                        options={filter.values}
                        //isClearable
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "#cfdde9",
                            primary: "#124760",
                          },
                        })}
                      />
                    </AccordionDetails>
                  </Accordion>
                ) : filter.name === "MmRange" ? (
                  <Accordion
                    square={true}
                    disableGutters={true}
                    sx={{
                      width: "100%",
                      minHeight: "unset",
                      paddingRight: "1rem",
                    }}
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography>{filter.label}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Select
                        key={filter.name}
                        value={mmSelect}
                        onChange={(e) => {
                          setMmSelect(e);
                          updateDropdownFilters(filter.name, e);
                        }}
                        options={filter.values}
                        //isClearable
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "#cfdde9",
                            primary: "#124760",
                          },
                        })}
                      />
                    </AccordionDetails>
                  </Accordion>
                ) : null}
              </React.Fragment>
            ))}
          <Accordion
            square={true}
            disableGutters={true}
            sx={{
              width: "100%",
              minHeight: "unset",
              paddingRight: "1rem",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Collection</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Divider flexItem sx={{ marginBottom: "2rem" }}>
                <Chip
                  label={<Typography variant="h6">Mined Diamonds</Typography>}
                  icon={<MinedIcon size="medium" />}
                  sx={{ backgroundColor: "unset" }}
                />
              </Divider>
              <Stack spacing={1}>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      variant="headerFont"
                      sx={{ lineHeight: "1.8rem" }}
                    >
                      <SignatureIcon /> Signature Melee
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          sm: "repeat(1, 1fr)",
                          md: "repeat(1, 1fr)",
                        },
                      }}
                    >
                      {collections.Signature &&
                        collections.Signature.map((signature) => (
                          <Chip
                            key={signature.label}
                            label={
                              <Typography variant="cellFont">
                                {signature.label}
                              </Typography>
                            }
                            sx={{
                              backgroundColor: "unset",
                              marginBottom: "0.5rem",
                            }}
                            onClick={() => clickButton(signature)}
                            color="primary"
                            variant={
                              _.find(buttons, function (button) {
                                return button === signature.value;
                              })
                                ? "filled"
                                : "outlined"
                            }
                          />
                        ))}
                    </Box>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={6}>
                    <Typography
                      variant="headerFont"
                      sx={{ lineHeight: "1.8rem" }}
                    >
                      <CanadaIcon /> Canadian Melee
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: {
                          sm: "repeat(1, 1fr)",
                          md: "repeat(1, 1fr)",
                        },
                      }}
                    >
                      {collections.Canadian &&
                        collections.Canadian.map((canadian) => (
                          <Chip
                            key={canadian.label}
                            label={
                              <Typography variant="cellFont">
                                {canadian.label}
                              </Typography>
                            }
                            sx={{
                              backgroundColor: "unset",
                              marginBottom: "0.5rem",
                            }}
                            onClick={() => clickButton(canadian)}
                            color="primary"
                            variant={
                              _.find(buttons, function (button) {
                                return button === canadian.value;
                              })
                                ? "filled"
                                : "outlined"
                            }
                          />
                        ))}
                    </Box>
                  </Grid>
                </Grid>
                {!matchedPairs && (
                  <Grid container>
                    <Grid item xs={6}>
                      <Typography
                        variant="headerFont"
                        sx={{ width: "100%", lineHeight: "1.8rem" }}
                      >
                        <RecycleIcon /> Harmony Melee
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Box
                        sx={{
                          display: "grid",
                          gridTemplateColumns: {
                            sm: "repeat(1, 1fr)",
                            md: "repeat(1, 1fr)",
                          },
                        }}
                      >
                        {collections.Harmony &&
                          collections.Harmony.map((harmony) => (
                            <Chip
                              key={harmony.label}
                              label={
                                <Typography variant="cellFont">
                                  {harmony.label}
                                </Typography>
                              }
                              sx={{
                                backgroundColor: "unset",
                                marginBottom: "0.5rem",
                              }}
                              onClick={() => clickButton(harmony)}
                              color="primary"
                              variant={
                                _.find(buttons, function (button) {
                                  return button === harmony.value;
                                })
                                  ? "filled"
                                  : "outlined"
                              }
                            />
                          ))}
                      </Box>
                    </Grid>
                  </Grid>
                )}
              </Stack>
              <Divider flexItem sx={{ marginBottom: "2rem" }}>
                <Chip
                  label={
                    <Typography variant="h6">Lab-Grown Diamonds</Typography>
                  }
                  icon={<LabGrownIcon size="medium" />}
                  sx={{ backgroundColor: "unset" }}
                />
              </Divider>
              <Grid container>
                <Grid item xs={6}>
                  <Typography
                    variant="headerFont"
                    sx={{ width: "100%", lineHeight: "1.8rem" }}
                  >
                    <BeakerIcon /> Lab-Grown Melee
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        sm: "repeat(1, 1fr)",
                        md: "repeat(1, 1fr)",
                      },
                    }}
                  >
                    {collections.Lab &&
                      collections.Lab.map((lab) => (
                        <Chip
                          key={lab.label}
                          label={
                            <Typography variant="cellFont">
                              {lab.label}
                            </Typography>
                          }
                          sx={{
                            backgroundColor: "unset",
                            marginBottom: "0.5rem",
                          }}
                          onClick={() => clickButton(lab)}
                          color="primary"
                          variant={
                            _.find(buttons, function (button) {
                              return button === lab.value;
                            })
                              ? "filled"
                              : "outlined"
                          }
                        />
                      ))}
                  </Box>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Stack>
      </Mobile>
      <Default>
        <Grid container justifyContent="center" sx={{ paddingTop: "2rem" }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                sm: "repeat(1, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(3, 1fr)",
                xl: "repeat(3, 1fr)",
              },
            }}
          >
            {filters.map((filter, index) => (
              <Stack
                key={index}
                direction="row"
                spacing={2}
                sx={{ marginLeft: "2rem" }}
              >
                {filter.name === "ShapeCode" ? (
                  <>
                    <Typography sx={{ width: "12%" }}>
                      {filter.label}
                    </Typography>
                    <Box
                      component="span"
                      sx={{
                        paddingLeft: "3rem",
                        paddingRight: "3rem",
                        width: "93%",
                      }}
                    >
                      {filter.type === "options" && filter.label === "Shape" ? (
                        <ShapeFilter updateFilters={updateFilters} />
                      ) : null}
                    </Box>
                  </>
                ) : filter.name === "CaratRange" ? (
                  <>
                    <Typography sx={{ width: "15%" }}>
                      {filter.label}
                    </Typography>
                    <div style={{ width: "75%" }}>
                      <Select
                        key={filter.name}
                        value={caratSelect}
                        onChange={(e) => {
                          setCaratSelect(e);
                          updateDropdownFilters(filter.name, e);
                        }}
                        options={filter.values}
                        //isClearable
                        isDisabled={mmSelect === null ? false : true}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "#cfdde9",
                            primary: "#124760",
                          },
                        })}
                      />
                    </div>
                  </>
                ) : filter.name === "MmRange" ? (
                  <>
                    <Typography sx={{ width: "17%" }}>
                      {filter.label}
                    </Typography>
                    <div style={{ width: "75%" }}>
                      <Select
                        key={filter.name}
                        value={mmSelect}
                        onChange={(e) => {
                          setMmSelect(e);
                          updateDropdownFilters(filter.name, e);
                        }}
                        options={filter.values}
                        //isClearable
                        isDisabled={caratSelect === null ? false : true}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            primary25: "#cfdde9",
                            primary: "#124760",
                          },
                        })}
                      />
                    </div>
                  </>
                ) : null}
              </Stack>
            ))}
          </Box>
        </Grid>
        <Grid container justifyContent="center" sx={{ paddingTop: "1rem" }}>
          <Stack direction="row" spacing={2}>
            <Box width="80%">
              <Paper
                variant="outlined"
                square
                sx={{ padding: "2rem", minHeight: "33rem" }}
              >
                <Stack justifyContent="center" alignItems="center" spacing={2}>
                  <Typography variant="mediumHeader">
                    <MinedIcon size="medium" /> Mined Diamonds
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={2} sx={{ marginTop: "2rem" }}>
                  <Grid item xs={5}>
                    <Stack spacing={2}>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>
                          <SignatureIcon size="medium" />
                        </Typography>
                        <Typography
                          variant="headerFont"
                          sx={{ width: "100%", lineHeight: "1.8rem" }}
                        >
                          Signature Melee
                        </Typography>
                      </Stack>
                      <Typography variant="cellFont" sx={{ width: "100%" }}>
                        Conflict-free, premium cut melee, strictly sorted and
                        graded, calibrated to 0.10mm
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={7}>
                    <Stack>
                      {collections.Signature &&
                        collections.Signature.map((signature, index) => (
                          <Button
                            key={index}
                            variant={
                              _.find(buttons, function (button) {
                                return button === signature.value;
                              })
                                ? "contained"
                                : "outlined"
                            }
                            sx={{ width: "125px" }}
                            onClick={() => clickButton(signature)}
                          >
                            {signature.label}
                          </Button>
                        ))}
                    </Stack>
                  </Grid>

                  <Grid item xs={5}>
                    <Stack spacing={2}>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>
                          <CanadaIcon size="medium" />
                        </Typography>
                        <Typography
                          variant="headerFont"
                          sx={{ width: "100%", lineHeight: "1.8rem" }}
                        >
                          Canadian Melee
                        </Typography>
                      </Stack>
                      <Typography variant="cellFont" sx={{ width: "100%" }}>
                        Canadian origin melee diamonds mined in accordane with
                        the highest environmental standards in the world;
                        calibrated to 0.10mm
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={7}>
                    <Stack>
                      {collections.Canadian &&
                        collections.Canadian.map((canadian, index) => (
                          <Button
                            key={index}
                            variant={
                              _.find(buttons, function (button) {
                                return button === canadian.value;
                              })
                                ? "contained"
                                : "outlined"
                            }
                            sx={{ width: "125px" }}
                            onClick={() => clickButton(canadian)}
                          >
                            {canadian.label}
                          </Button>
                        ))}
                    </Stack>
                  </Grid>

                  <Grid item xs={5}>
                    <Stack spacing={2}>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>
                          <RecycleIcon size="medium" />
                        </Typography>
                        <Typography
                          variant="headerFont"
                          sx={{ width: "100%", lineHeight: "1.8rem" }}
                        >
                          Harmony Melee
                        </Typography>
                      </Stack>
                      {matchedPairs ? (
                        <Typography variant="cellFont" sx={{ width: "100%" }}>
                          Call to confirm availability of Harmony matched pairs.
                        </Typography>
                      ) : (
                        <Typography variant="cellFont" sx={{ width: "100%" }}>
                          Recycled melee diamonds, the most eco-friendly natural
                          diamonds available offered at discounted prices and
                          calibrated to 0.10mm
                        </Typography>
                      )}
                    </Stack>
                  </Grid>
                  <Grid item xs={7}>
                    <Stack>
                      {collections.Harmony &&
                        collections.Harmony.map((harmony, index) => (
                          <Button
                            key={index}
                            disabled={matchedPairs ? true : false}
                            variant={
                              _.find(buttons, function (button) {
                                return button === harmony.value;
                              })
                                ? "contained"
                                : "outlined"
                            }
                            sx={{ width: "125px" }}
                            onClick={() => clickButton(harmony)}
                          >
                            {harmony.label}
                          </Button>
                        ))}
                    </Stack>
                  </Grid>
                </Stack>
              </Paper>
            </Box>
            <Box width="40%">
              <Paper
                variant="outlined"
                square
                sx={{ padding: "2rem", minHeight: "33rem" }}
              >
                <Stack justifyContent="center" alignItems="center" spacing={1}>
                  <Typography variant="mediumHeader">
                    <LabGrownIcon /> Lab-Grown Diamonds
                  </Typography>
                </Stack>
                <Stack
                  direction="row"
                  justifyContent="center"
                  sx={{ marginTop: "2rem" }}
                  spacing={3}
                >
                  <Grid item xs={4}>
                    <Stack spacing={2}>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>
                          <BeakerIcon size="medium" />
                        </Typography>
                        <Typography
                          variant="headerFont"
                          sx={{ width: "100%", lineHeight: "1.8rem" }}
                        >
                          Lab-Grown Melee
                        </Typography>
                      </Stack>
                      <Typography variant="cellFont" sx={{ width: "100%" }}>
                        Lab grown diamonds, made using the most technologically
                        advanced and sustainable alternative HPHT process.
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item xs={5}>
                    <Stack>
                      {collections.Lab &&
                        collections.Lab.map((lab, index) => (
                          <Button
                            key={index}
                            variant={
                              _.find(buttons, function (button) {
                                return button === lab.value;
                              })
                                ? "contained"
                                : "outlined"
                            }
                            sx={{ width: "125px" }}
                            onClick={() => clickButton(lab)}
                          >
                            {lab.label}
                          </Button>
                        ))}
                    </Stack>
                  </Grid>
                </Stack>
              </Paper>
            </Box>
          </Stack>
        </Grid>
      </Default>
    </>
  );
}
